import styled from 'styled-components';
import { down } from 'styled-breakpoints';

import { Utils } from 'billon-ui';
const { Text } = Utils;

export const Title = styled(Text)`
  font-size: 2.5rem;
  line-height: 48px;
  font-weight: ${(props) => props.theme.fontWeightBold};
  margin-bottom: 0px;
  ${down('lg')} {
    font-size: 1.9rem;
  }
  ${down('sm')} {
    font-size: 1.75rem;
  }
`;

export const Description = styled(Text)`
  font-size: 1rem;
  font-weight: ${(props) => props.theme.fontWeightMedium};
  margin-bottom: 2rem;
`;
